export enum LOCALES {
	FRENCH = 'fr',
	ENGLISH = 'en',
	GERMAN = 'de',
	POLISH = 'pl',
}

// TODO refactor to be dynamic
